import React, { useEffect, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { useSelector } from 'react-redux';
import { langSelector } from '../store/langSlice';

export default function CustomMultipleSelect({
  items,
  placeholder,
  setValue,
  isError,
  error
}) {
  const [selectedData, setSelectedData] = useState([]);
  const [itemsData, setItemsData] = useState(items);

  const lang = useSelector(langSelector);

  const addItemToList = (item, list) => {
    return [...list, item];
  }

  const removeItemFromList = (item, list) => {
    return list.filter(i => i !== item);
  }

  useEffect(() => {
    setValue(selectedData.map((item) => item.value));
  }, [selectedData, setValue]);

  return (
    <>
      <div className={`grid grid-cols-1 ${isError ? 'mb-0' : 'mb-5'} gap-5 md:grid-cols-2`}>
        <div className={`w-full border-2 rounded-[20px] h-[185px] ${isError ? 'border-primary' : 'border-gray'}`}>
          <p className='font-inter font-medium text-2xl sm:text-3xl px-5 pt-5 pb-2 text-[#9ca3af]' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{placeholder}</p>
          <div className='h-[100px] overflow-y-scroll'>
            {itemsData.map((item) => {
              return (
                <p
                  key={item.id}
                  className='cursor-pointer py-2 px-5 w-full hover:bg-primary hover:text-white text-3xl font-regular'
                  style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}
                  onClick={() => {
                    setSelectedData((prevState) => [...prevState, item]);
                    setItemsData((prevState) => removeItemFromList(item, prevState));
                  }}
                >
                    {item.label}
                </p>
              );
            })}
          </div>
        </div>
        <div className={`w-full border-2 rounded-[20px] h-[185px] ${isError ? 'border-primary' : 'border-gray'}`}>
          <p className='font-inter font-medium text-2xl sm:text-3xl px-5 pt-5 pb-2 text-[#9ca3af]' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{placeholder}</p>
          <div className='h-[100px] flex items-start flex-wrap gap-2 overflow-y-scroll px-5 pt-2'>
            {selectedData.map((item, index) => {
              return (
                <span
                  key={index}
                  className='bg-primary px-5 py-1 text-white text-2xl mr-5 rounded-full hover:bg-primaryDark cursor-pointer flex items-center'
                  onClick={() => {
                    setSelectedData((prevState) => removeItemFromList(item, prevState));
                    setItemsData((prevState) => addItemToList(item, prevState));
                  }}
                >
                  <p className='relative bottom-0.5 pr-2 border-right' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{item.label}</p>
                  <ClearIcon />
                </span>
              );
            })}
          </div>
        </div>
      </div>
      <p className={`relative mb-5 pl-5 font-medium text-xl text-primary ${isError ? 'block' : 'hidden'}`}>{error}</p>
    </>
  );
}
